/**
 * Calcula o tempo gasto entre hora início e hora fim
 * @param {string} start - Hora início no formato HH:MM
 * @param {string} end - Hora fim no formato HH:MM
 * @returns {string} Tempo gasto no formato HH:MM ou string vazia se inválido
 */
export const calculateTimeSpent = (start, end) => {
  if (!start || !end) return '';

  const [startHours, startMinutes] = start.split(':').map(Number);
  const [endHours, endMinutes] = end.split(':').map(Number);

  if (
    isNaN(startHours) ||
    isNaN(startMinutes) ||
    isNaN(endHours) ||
    isNaN(endMinutes)
  ) {
    return '';
  }

  let totalMinutes =
    endHours * 60 + endMinutes - (startHours * 60 + startMinutes);

  if (totalMinutes < 0) {
    totalMinutes += 24 * 60; // Handle next day
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
    2,
    '0'
  )}`;
};

/**
 * Calcula a hora fim baseada na hora início e no tempo gasto
 * @param {string} start - Hora início no formato HH:MM
 * @param {string} timeSpent - Tempo gasto no formato HH:MM
 * @returns {string} Hora fim no formato HH:MM ou string vazia se inválido
 */
export const calculateEndTimeFromStartAndTimeSpent = (start, timeSpent) => {
  if (!start || !timeSpent) return '';

  const [startHours, startMinutes] = start.split(':').map(Number);
  const [timeSpentHours, timeSpentMinutes] = timeSpent.split(':').map(Number);

  if (
    isNaN(startHours) ||
    isNaN(startMinutes) ||
    isNaN(timeSpentHours) ||
    isNaN(timeSpentMinutes)
  ) {
    return '';
  }

  const startTotalMinutes = startHours * 60 + startMinutes;
  const timeSpentTotalMinutes = timeSpentHours * 60 + timeSpentMinutes;
  const endTotalMinutes = startTotalMinutes + timeSpentTotalMinutes;

  const endHours = Math.floor(endTotalMinutes / 60) % 24;
  const endMinutes = endTotalMinutes % 60;

  return `${String(endHours).padStart(2, '0')}:${String(endMinutes).padStart(
    2,
    '0'
  )}`;
};

/**
 * Calcula a hora início baseada na hora fim e no tempo gasto
 * @param {string} end - Hora fim no formato HH:MM
 * @param {string} timeSpent - Tempo gasto no formato HH:MM
 * @returns {string} Hora início no formato HH:MM ou string vazia se inválido
 */
export const calculateStartTimeFromEndAndTimeSpent = (end, timeSpent) => {
  if (!end || !timeSpent) return '';

  const [endHours, endMinutes] = end.split(':').map(Number);
  const [timeSpentHours, timeSpentMinutes] = timeSpent.split(':').map(Number);

  if (
    isNaN(endHours) ||
    isNaN(endMinutes) ||
    isNaN(timeSpentHours) ||
    isNaN(timeSpentMinutes)
  ) {
    return '';
  }

  const endTotalMinutes = endHours * 60 + endMinutes;
  const timeSpentTotalMinutes = timeSpentHours * 60 + timeSpentMinutes;
  let startTotalMinutes = endTotalMinutes - timeSpentTotalMinutes;

  if (startTotalMinutes < 0) {
    startTotalMinutes += 24 * 60; // Handle previous day
  }

  const startHours = Math.floor(startTotalMinutes / 60) % 24;
  const startMinutes = startTotalMinutes % 60;

  return `${String(startHours).padStart(2, '0')}:${String(
    startMinutes
  ).padStart(2, '0')}`;
};
